<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{
      span: 10,
    }"
    :wrapper-col="{
      span: 13,
    }"
  >
    <a-form-item ref="name" label="车型名" name="name">
      <a-input v-model:value="formState.name" />
    </a-form-item>
    <a-form-item ref="speed" label="车速" name="speed">
      <a-input-number
        style="width: 200px"
        v-model:value="formState.speed"
        placeholder="范围0-300"
        :min="0"
        :max="300"
      />
      km/h
    </a-form-item>
    <a-form-item ref="needRecord" label="是否需要备案" name="needRecord">
      <a-radio-group v-model:value="formState.needRecord">
        <a-radio-button :value="0">不需要</a-radio-button>
        <a-radio-button :value="1">需要</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item ref="showCargoType" label="显示货物类型" name="showCargoType">
      <a-radio-group v-model:value="formState.showCargoType">
        <a-radio-button :value="0">不显示</a-radio-button>
        <a-radio-button :value="1">显示</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item ref="checkOverweight" label="判断超重" name="checkOverweight">
      <a-radio-group v-model:value="formState.checkOverweight">
        <a-radio-button :value="0">不需要</a-radio-button>
        <a-radio-button :value="1">需要</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item ref="needBlindVideo" label="是否需要盲区视频监控图片" name="needBlindVideo">
      <a-radio-group v-model:value="formState.needBlindVideo">
        <a-radio-button :value="0">不需要</a-radio-button>
        <a-radio-button :value="1">需要</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item ref="needTruckDriverLicense" label="是否需要驾驶证图片" name="needTruckDriverLicense">
      <a-radio-group v-model:value="formState.needTruckDriverLicense">
        <a-radio-button :value="0">不需要</a-radio-button>
        <a-radio-button :value="1">需要</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item ref="needTrailerRegistration" label="是否需要挂车行驶证及挂车图片（含车牌号）" name="needTrailerRegistration">
      <a-radio-group v-model:value="formState.needTrailerRegistration">
        <a-radio-button :value="0">不需要</a-radio-button>
        <a-radio-button :value="1">需要</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item ref="needTruckCompulsoryInsurance" label="是否需要强制险图片" name="needTrailerRegistration">
      <a-radio-group v-model:value="formState.needTruckCompulsoryInsurance">
        <a-radio-button :value="0">不需要</a-radio-button>
        <a-radio-button :value="1">需要</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item ref="needTruckCommercialInsurance" label="是否需要商业险图片" name="needTrailerRegistration">
      <a-radio-group v-model:value="formState.needTruckCommercialInsurance">
        <a-radio-button :value="0">不需要</a-radio-button>
        <a-radio-button :value="1">需要</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item ref="onlineReservation" label="是否允许线上预约" name="onlineReservation">
      <a-radio-group v-model:value="formState.onlineReservation">
        <a-radio-button :value="0">否</a-radio-button>
        <a-radio-button :value="1">是</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 8 }">
      <a-button type="primary" @click="onSubmit">提交</a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
  import { reactive, ref, toRaw, defineProps, defineEmits } from 'vue'
  import { message } from 'ant-design-vue'
  import { createModal, updateModal } from '@/api/system_manage/modal'

  const props = defineProps({ isEdit: Boolean, editData: Object, data: Array })
  const emit = defineEmits(['submit'])
  const formRef = ref()

  const defaultFormState = props.isEdit
    ? {
        id: props.editData.id,
        name: props.editData.name,
        speed: props.editData.speed,
        needRecord: props.editData.need_record,
        showCargoType: props.editData.show_cargo_type,
        checkOverweight: props.editData.check_overweight,
        needBlindVideo: props.editData.need_blind_video,
        needTruckDriverLicense: props.editData.need_truck_driver_license,
        needTrailerRegistration: props.editData.need_trailer_registration,
        needTruckCompulsoryInsurance: props.editData.need_truck_compulsory_insurance,
        needTruckCommercialInsurance: props.editData.need_truck_commercial_insurance,
        onlineReservation: props.editData.online_reservation,
      }
    : {
        name: '',
        speed: '',
        needRecord: '',
        showCargoType: '',
        checkOverweight: '',
        needBlindVideo: '',
        needTruckDriverLicense: 0,
        needTrailerRegistration: 0,
        needTruckCompulsoryInsurance: 0,
        needTruckCommercialInsurance: 0,
        onlineReservation: '',
      }
  const formState = reactive(defaultFormState)
  const rules = {
    name: [
      {
        required: true,
        message: '请输入车型名',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个文字',
        trigger: 'blur',
      },
    ],
    speed: [
      {
        required: true,
        message: '请输入车速',
        trigger: 'change',
      },
    ],
    needRecord: [
      {
        required: true,
        message: '请选择预约是否需要备案',
        trigger: 'blur',
      },
    ],
    showCargoType: [
      {
        required: true,
        message: '请选择页面是否显示货物类型',
        trigger: 'blur',
      },
    ],
    checkOverweight: [
      {
        required: true,
        message: '请选择是否需要判断超重',
        trigger: 'blur',
      },
    ],
    needTruckDriverLicense: [
      {
        required: true,
        message: '请选择页面是否需要上传驾驶证图片',
        trigger: 'blur',
      },
    ],
    needTrailerRegistration: [
      {
        required: true,
        message: '请选择页面是否需要上传挂车行驶证及挂车图片（含车牌号）',
        trigger: 'blur',
      },
    ],
    needTruckCompulsoryInsurance: [
      {
        required: true,
        message: '请选择页面是否需要上传交强险',
        trigger: 'blur',
      },
    ],
    needTruckCommercialInsurance: [
      {
        required: true,
        message: '请选择页面是否需要上传商业',
        trigger: 'blur',
      },
    ],
    needBlindVideo: [
      {
        required: true,
        message: '请选择页面是否需要上传盲区视频监控图片',
        trigger: 'blur',
      },
    ],
    onlineReservation: [
      {
        required: true,
        message: '请选择是否允许线上预约',
        trigger: 'blur',
      },
    ],
  }
  async function handelCreate(data) {
    const ajaxFn = props.isEdit ? updateModal : createModal
    const messageText = props.isEdit ? '编辑' : '创建'
    const res = await ajaxFn(data)
    if (res.success) {
      message.success(messageText + '车型成功！')
      emit('submit')
    } else {
      message.warn(messageText + '车型错误：', res.message)
    }
  }
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelCreate(toRaw(formState))
      })
      .catch((error) => {
        console.log('创建车型错误：', error)
      })
  }

  function resetForm() {
    formRef.value.resetFields()
  }
</script>
